/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     nz-skeleton div.ant-skeleton-header span.ant-skeleton-avatar{width:110px;height:110px}[_nghost-%COMP%]     nz-skeleton.small div.ant-skeleton-header span.ant-skeleton-avatar{width:70px;height:70px}[_nghost-%COMP%]     nz-skeleton.extra-small div.ant-skeleton-header span.ant-skeleton-avatar{width:60px;height:60px}[_nghost-%COMP%]     div.ant-skeleton-content{display:none}"];
export { styles as styles };
